__turbopack_context__.v({
  "blockHero": "BlockHero-module-scss-module__zNryeW__blockHero",
  "blockHero-loader": "BlockHero-module-scss-module__zNryeW__blockHero-loader",
  "blockHero-reveal": "BlockHero-module-scss-module__zNryeW__blockHero-reveal",
  "blockHero-scroll": "BlockHero-module-scss-module__zNryeW__blockHero-scroll",
  "cover": "BlockHero-module-scss-module__zNryeW__cover",
  "eyebrow": "BlockHero-module-scss-module__zNryeW__eyebrow",
  "fade-in": "BlockHero-module-scss-module__zNryeW__fade-in",
  "headline": "BlockHero-module-scss-module__zNryeW__headline",
  "isInView": "BlockHero-module-scss-module__zNryeW__isInView",
  "logo": "BlockHero-module-scss-module__zNryeW__logo",
  "logoContainer": "BlockHero-module-scss-module__zNryeW__logoContainer",
  "logoType": "BlockHero-module-scss-module__zNryeW__logoType",
  "logoWrapper": "BlockHero-module-scss-module__zNryeW__logoWrapper",
  "morningStar": "BlockHero-module-scss-module__zNryeW__morningStar",
  "reveal": "BlockHero-module-scss-module__zNryeW__reveal",
  "scrollIndicator": "BlockHero-module-scss-module__zNryeW__scrollIndicator",
  "secondaryHero": "BlockHero-module-scss-module__zNryeW__secondaryHero",
  "tagline": "BlockHero-module-scss-module__zNryeW__tagline",
  "taglineContent": "BlockHero-module-scss-module__zNryeW__taglineContent",
  "video": "BlockHero-module-scss-module__zNryeW__video",
  "videoContainer": "BlockHero-module-scss-module__zNryeW__videoContainer",
});
